import React from 'react';
import config from '../config';
import useFetch from '../utils/hooks/useFetch';
import './Footer.scss';

export default function Footer() {
  const { loading, data } = useFetch(config.contentApi.headerFooter);
  if (loading) return null;

  return (
    <footer className="footer">
      <div className="footer-logo d-flex justify-content-center py-2">
        <a className="logo" href="/">
          <img src={data.spectrumMobileLogo} alt="Spectrum Mobile" />
        </a>
      </div>

      <div className="navbar navbar-expand-lg text-light py-3 py-md-4 footer-nav">
        <div className="navbar-collapse" id="navbarNav">
          <div className="d-flex justify-content-center w-100 text-center">
            © {new Date().getFullYear()} Charter Communications. All rights reserved.
          </div>
        </div>
      </div>

    </footer>
  );
}
